import React from 'react';
import { theme } from '../../config/theme';
import { useMobileCollapse } from '../../hooks/useMobileCollapse';
import CollapsibleHeader from './CollapsibleHeader';

const styles = {
    wrapper: {
        marginBottom: '1rem',
        backgroundColor: theme.colors.surface,
        borderRadius: theme.borderRadius,
        boxShadow: theme.shadows.soft,
        borderLeft: `3px solid ${theme.colors.primary}`,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
    },
    title: {
        fontFamily: theme.typography.titleFamily,
        fontSize: '0.85rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: theme.colors.primary,
    },
    summary: {
        fontSize: '0.75rem',
        color: theme.colors.textSecondary,
    },
    body: {
        padding: '0.25rem 0.75rem 0.75rem',
    },
};

/**
 * Bloque secundario (indicadores, gráficos, carga masiva) que en el celular se
 * pliega detrás de una barra para que lo principal de la pestaña quede a la
 * vista. En escritorio renderiza los hijos tal cual, sin envoltorio.
 */
const MobileCollapsibleSection = ({ title, summary, initiallyOpen = false, children }) => {
    const { isMobile, isOpen, toggle } = useMobileCollapse(initiallyOpen);
    if (!isMobile) return <>{children}</>;

    return (
        <div style={styles.wrapper}>
            <CollapsibleHeader isMobile isOpen={isOpen} onToggle={toggle} style={styles.header}>
                <span style={styles.title}>{title}</span>
                {summary && !isOpen && <span style={styles.summary}>{summary}</span>}
            </CollapsibleHeader>
            {isOpen && <div style={styles.body}>{children}</div>}
        </div>
    );
};

export default MobileCollapsibleSection;
